module.exports = __webpack_public_path__ + "img/logo-dorfladen-full.c563ded7.png";